import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
const Page = lazy(() => import("@/features/config-comission-pass/page.client"));
export const Route = createFileRoute("/_authed/staff/commission-pass-config")({
  component: () => (
    <Suspense fallback={null}>
      <Page />
    </Suspense>
  ),
});
